export default "__VITE_ASSET__Dx68o05B__"